import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PowerplantRoutingModule } from './powerplant-routes.module';
import { PowerplantService } from './powerplant.service';
import { PowerplantComponent } from './powerplant.component';


@NgModule({
  declarations: [
    PowerplantComponent
  ],
  imports: [
    CommonModule,
    
    PowerplantRoutingModule,
  ],
  providers: [
    PowerplantService
  ],
  exports: []
})
export class PowerplantModule { }
